export const imports = {
  'slides/browserSupport.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "slides-browser-support" */ 'slides/browserSupport.mdx'
    ),
  'slides/collapseCss.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "slides-collapse-css" */ 'slides/collapseCss.mdx'
    ),
  'slides/collapseJs.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "slides-collapse-js" */ 'slides/collapseJs.mdx'
    ),
  'slides/collapseJsSpeed.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "slides-collapse-js-speed" */ 'slides/collapseJsSpeed.mdx'
    ),
  'slides/compareCss.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "slides-compare-css" */ 'slides/compareCss.mdx'
    ),
  'slides/compareJs.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "slides-compare-js" */ 'slides/compareJs.mdx'
    ),
  'slides/conclusion.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "slides-conclusion" */ 'slides/conclusion.mdx'
    ),
  'slides/disclaimer.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "slides-disclaimer" */ 'slides/disclaimer.mdx'
    ),
  'slides/funDemo.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "slides-fun-demo" */ 'slides/funDemo.mdx'
    ),
  'slides/intro.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "slides-intro" */ 'slides/intro.mdx'
    ),
  'slides/introOfWaapi.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "slides-intro-of-waapi" */ 'slides/introOfWaapi.mdx'
    ),
  'slides/me.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "slides-me" */ 'slides/me.mdx'
    ),
  'slides/playStates.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "slides-play-states" */ 'slides/playStates.mdx'
    ),
  'slides/playStatesDemo.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "slides-play-states-demo" */ 'slides/playStatesDemo.mdx'
    ),
  'slides/playStatesOverview.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "slides-play-states-overview" */ 'slides/playStatesOverview.mdx'
    ),
  'slides/sources.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "slides-sources" */ 'slides/sources.mdx'
    ),
  'slides/summary.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "slides-summary" */ 'slides/summary.mdx'
    ),
  'slides/thanks.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "slides-thanks" */ 'slides/thanks.mdx'
    ),
  'slides/timelineControls.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "slides-timeline-controls" */ 'slides/timelineControls.mdx'
    ),
  'slides/timelineControlsDemo.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "slides-timeline-controls-demo" */ 'slides/timelineControlsDemo.mdx'
    ),
  'slides/timelineControlsOverview.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "slides-timeline-controls-overview" */ 'slides/timelineControlsOverview.mdx'
    ),
  'slides/tumbleAlice.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "slides-tumble-alice" */ 'slides/tumbleAlice.mdx'
    ),
}
